import { FormattedMessage } from 'react-intl';
import { Flags } from './Flags';
import { ReactNode } from 'react';

export default {
  us_nj: {
    icon: Flags.usa,
    label: <FormattedMessage id="us_nj" defaultMessage="US NJ" />,
    text: 'US NJ',
  },
  south_africa: {
    icon: Flags.southAfrica,
    label: (
      <FormattedMessage
        id="southAfrica"
        defaultMessage="South Africa"
      />
    ),
    text: 'South Africa',
  },
  mga: {
    icon: Flags.malta,
    label: (
      <FormattedMessage id="ukMalta" defaultMessage="UK/Malta" />
    ),
    text: 'UK/Malta',
  },
  portugal: {
    icon: Flags.portugal,
    label: (
      <FormattedMessage id="portugal" defaultMessage="Portugal" />
    ),
    text: 'Portugal',
  },
  brazil: {
    icon: Flags.brazil,
    label: <FormattedMessage id="brazil" defaultMessage="Brazil" />,
    text: 'Brazil',
  },
  buenos_aires: {
    icon: Flags.argentina,
    label: (
      <FormattedMessage
        id="buenosAires"
        defaultMessage="Buenos Aires"
      />
    ),
    text: 'Buenos Aires',
  },
  colombia: {
    icon: Flags.colombia,
    label: (
      <FormattedMessage id="colombia" defaultMessage="Colombia" />
    ),
    text: 'Colombia',
  },
  curacao: {
    icon: Flags.curacao,
    label: <FormattedMessage id="curacao" defaultMessage="Curacao" />,
    text: 'Curacao',
  },
  georgia: {
    icon: Flags.georgia,
    label: <FormattedMessage id="georgia" defaultMessage="Georgia" />,
    text: 'Georgia',
  },
  italy: {
    icon: Flags.italy,
    label: <FormattedMessage id="italy" defaultMessage="Italy" />,
    text: 'Italy',
  },
  netherlands: {
    icon: Flags.netherlands,
    label: (
      <FormattedMessage
        id="netherlands"
        defaultMessage="Netherlands"
      />
    ),
    text: 'Netherlands',
  },
  ontario: {
    icon: Flags.canada,
    label: <FormattedMessage id="ontario" defaultMessage="Ontario" />,
    text: 'Ontario',
  },
  peru: {
    icon: Flags.peru,
    label: <FormattedMessage id="peru" defaultMessage="Peru" />,
    text: 'Peru',
  },
  romania: {
    icon: Flags.romania,
    label: <FormattedMessage id="romania" defaultMessage="Romania" />,
    text: 'Romania',
  },
  'south africa': {
    icon: Flags.southAfrica,
    label: (
      <FormattedMessage
        id="southAfrica"
        defaultMessage="South Africa"
      />
    ),
    text: 'South Africa',
  },
  spain: {
    icon: Flags.spain,
    label: <FormattedMessage id="spain" defaultMessage="Spain" />,
    text: 'Spain',
  },
  greece: {
    icon: Flags.greece,
    label: <FormattedMessage id="greece" defaultMessage="Greece" />,
    text: 'Greece',
  },
  switzerland: {
    icon: Flags.switzerland,
    label: (
      <FormattedMessage
        id="switzerland"
        defaultMessage="Switzerland"
      />
    ),
    text: 'Switzerland',
  },
  us_pa: {
    icon: Flags.pennsylvania,
    label: (
      <FormattedMessage
        id="pennsylvania"
        defaultMessage="Pennsylvania"
      />
    ),
    text: 'Pennsylvania',
  },
  us_wv: {
    icon: Flags.westVirginia,
    label: (
      <FormattedMessage
        id="westVirginia"
        defaultMessage="West Virginia"
      />
    ),
    text: 'West Virginia',
  },
  alberta: {
    icon: Flags.alberta,
    label: <FormattedMessage id="alberta" defaultMessage="Alberta" />,
    text: 'Alberta',
  },
} as Record<
  string,
  { icon?: React.ReactNode; label: ReactNode; text: string }
>;
